export function getFileName (file) {
  return file?.name || file?.file_name
}

export function getFileSize (file) {
  return file.size || file.file_size
}

export function getFileURL (file) {
  if (file.url) return file.url

  return URL.createObjectURL(file)
}

export function getNewFiles (files) {
  if (!files?.length) return []
  return files.filter(file => !file.id)
}
